// A popup nested inside a Modal (a colour-swatch panel, for one) marks its root
// with this attribute while it is open. Modal's document-level Escape handler
// checks for it and leaves that press to the popup, so Escape closes the popup
// first and the modal only on the next press.
export const MODAL_ESCAPE_LAYER_ATTRIBUTE = 'data-modal-escape-layer';
